import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const InputControl = ({ value, onChange, id, onTouched, type, disabled, placeholder }) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Box autoComplete="off">
      <TextField
        sx={{
          fontWeight: "normal",
          backgroundColor: disabled ? "#EEEEEE" : "white",
          borderRadius:"5px",
          ".MuiOutlinedInput-root": {
            borderRadius: "5px", // Remove border radius here
            "& .MuiInputBase-input": {
              padding: "10px", // Add padding here
            },
          },
        }}
        id={id}
        value={value || ""}
        type={type}
        disabled={disabled}
        onChange={handleChange}
        onBlur={onTouched}
        fullWidth
        size="small"
        placeholder={placeholder}
      />
    </Box>
  );
};

export default InputControl;
